import React from 'react';
import { Space, Typography } from 'antd';
import PosTerminal from './PosTerminal';

const { Title } = Typography;

// The full Point of Sale screen (/pos): the shared till plus member search.
// The same terminal is reused in a modal from a member profile, where the
// member is already known — see PosTransactionModal.
const PointOfSale: React.FC = () => (
    <Space direction="vertical" style={{ width: '100%', padding: '24px' }}>
        <Title level={2}>Point of Sale</Title>
        <PosTerminal />
    </Space>
);

export default PointOfSale;
